import { ActionsMenu } from 'web-interactives-dashboard-ui/components/shared/actionsMenu';
import { InteractiveMenuOptions } from '../shared/actionsMenu/InteractiveMenuOptions';
import { jsx as _jsx } from "react/jsx-runtime";
const DetailsActionsMenu = ({
  buttonProps,
  interactiveData
}) => {
  // Early return because conditional menu action list causes styling issues
  if (!interactiveData) {
    return /*#__PURE__*/_jsx(ActionsMenu, Object.assign({
      "data-test-id": "details-actions-menu",
      disabled: true
    }, buttonProps));
  }
  return /*#__PURE__*/_jsx(ActionsMenu, Object.assign({
    "data-test-id": "details-actions-menu"
  }, buttonProps, {
    children: /*#__PURE__*/_jsx(InteractiveMenuOptions, Object.assign({}, interactiveData, {
      context: "details"
    }))
  }));
};
export default DetailsActionsMenu;